import { queryButtonClickLog } from '@/pages/accountCenter/requests';

const initPagination = {
  pageSize: 10,
  currentPage: 1,
  total: 0,
};

const Model = {
  namespace: 'operationAudit',
  state: {
    tabledData: [],
    pagination: initPagination,
  },
  effects: {
    *getButtonClickLogs({ payload }, { call, put }) {
      const res = yield call(queryButtonClickLog, payload);
      if (res && res.code === 0) {
        yield put({
          type: 'saveButtonClickLogs',
          payload: res.data,
        });
      }
    },
  },
  reducers: {
    saveButtonClickLogs(state, { payload }) {
      const { dataInfos = [], total = 0, pageNum = 1, pageSize = 10 } = payload || {};
      return {
        ...state,
        tabledData: dataInfos,
        pagination: {
          currentPage: pageNum,
          pageSize,
          total,
        },
      };
    },
  },
};

export default Model;
